import React from "react";
import styled from "styled-components";
import { font, shadow } from "../tokens";
import {
  DisplayTitle,
  Inner,
  MonoLabel,
  Reveal,
  SectionRow,
  RowMeta,
  TwoTone,
} from "../primitives";
import { STACK_CLUSTERS } from "../data";
import AnimatedIcon from "../icons";

const Wrap = styled.div`
  padding-bottom: clamp(120px, 22vh, 240px);
`;

const Grid = styled.div`
  margin-top: clamp(40px, 7vh, 80px);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: clamp(14px, 1.6vw, 24px);
`;

const Card = styled.div`
  background: #fdfcf9;
  border-radius: 16px;
  padding: 20px 20px 18px;
  box-shadow: ${shadow.card};
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 260px;
`;

const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-family: ${font.display};
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

/* Minimal listing: hairline-separated mono rows, no boxes. */
const RowList = styled.ul`
  margin: 0;
  margin-top: auto;
  padding: 0;
  list-style: none;
`;

const TechRow = styled.li`
  font-family: ${font.mono};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 7px 0;
  border-top: 1px solid rgba(14, 14, 12, 0.1);
  color: rgba(14, 14, 12, 0.72);
`;

/** Stack index: five upright service cards, entrance stagger. */
const StackSection: React.FC = () => (
  <Wrap id="stack">
    <Inner>
      <Reveal>
        <SectionRow>
          <MonoLabel as="h2" style={{ margin: 0 }}>
            Stack index
          </MonoLabel>
          <div>
            <DisplayTitle as="p" style={{ marginBottom: 24 }}>
              Stack
            </DisplayTitle>
            <TwoTone
              ink="The tools that keep showing up."
              muted="Eight years of production TypeScript, with AI woven through the recent ones."
            />
          </div>
          <RowMeta>
            <AnimatedIcon name="layers" size={16} strokeWidth={2} />
          </RowMeta>
        </SectionRow>
      </Reveal>
      <Grid>
        {STACK_CLUSTERS.map((cluster, i) => {
          const serial = `STK-${String(i + 1).padStart(2, "0")}`;
          return (
            <Reveal key={cluster.label} delay={Math.min(i * 0.08, 0.32)}>
              <Card>
                <CardHead>
                  <MonoLabel>{serial}</MonoLabel>
                  <AnimatedIcon
                    name={cluster.icon}
                    size={18}
                    strokeWidth={1.8}
                  />
                </CardHead>
                <CardTitle>{cluster.label}</CardTitle>
                <RowList>
                  {cluster.chips.map((chip) => (
                    <TechRow key={chip}>{chip}</TechRow>
                  ))}
                </RowList>
              </Card>
            </Reveal>
          );
        })}
      </Grid>
    </Inner>
  </Wrap>
);

export default StackSection;
